import React, { Component } from 'react';
import LayoutPages from '../../Components/LayoutPages';
import {
    Row,
    Col,
    Spin,
    Tabs
} from 'antd';
import './Perfil.css';

import AuthService from '../../Components/AuthService';
import UserProvider from '../../js/userProvider';
import DataService from '../../Components/Data';
import DadosPerfil from '../../Components/DadosPerfil/DadosPerfil';
import DadosBancarios from '../../Components/DadosBancarios/DadosBancarios';
import CartaoCredito from '../../Components/CartaoCredito/CartaoCredito';

const Auth = new AuthService();
const TabPane = Tabs.TabPane;

class Perfil extends Component {

    constructor(props) {
        super(props);

        this.state = {
            buscando: false
        }

        this.dataService = new DataService();
        this.dadosProvider = UserProvider.getInstance();
        this.menusOcultos = [];
    }

    componentWillMount() {

        var usuario = this.dadosProvider.getDadosUsuario();

        if (usuario == null) {
            Auth.logout();
            this.props.history.push('/login');
        }
        
        this.menusOcultos = this.dadosProvider.getMenusOcultos();
    }    

    render() {

        return (
            <LayoutPages pageTitle="Perfil" history={this.props.history} pageIndex="6">
                <div>

                    {this.state.buscando ?
                        (<Row>
                            <Col className="imageRadio">
                                <div className="divSpin">
                                    <Spin className="imageSpin" />
                                </div>
                            </Col>
                        </Row>) :

                        (
                            <Tabs defaultActiveKey="1" size="small">
                                {this.menusOcultos.indexOf(158) == -1 ? 
                                    <TabPane tab="Perfil" key="1">                                    
                                        <DadosPerfil />
                                    </TabPane>
                                : null}
                                {this.menusOcultos.indexOf(159) == -1 ? 
                                    <TabPane tab="Dados Bancários" key="2">
                                        <DadosBancarios />
                                    </TabPane>
                                : null}
                                {this.menusOcultos.indexOf(160) == -1 ? 
                                    <TabPane tab="Cartão de Crédito" key="3">
                                        <CartaoCredito/>
                                    </TabPane>
                                : null}
                            </Tabs>
                        )

                    }
                </div>
            </LayoutPages >
        )
    }
}

export default Perfil;


// WEBPACK FOOTER //
// ./src/Pages/Perfil/Perfil.js